import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Ui, Heading1, Heading2, Heading3, Heading4, Heading5, Heading6, Subtitle, SecondaryText } from "@silvertours/front-shared";
import { Icon } from "./Icon";
import { HeadingWrapper } from "./Heading.styles";
var headingMap = {
    h1: Heading1,
    h2: Heading2,
    h3: Heading3,
    h4: Heading4,
    h5: Heading5,
    h6: Heading6
};
export var Heading = function(param) {
    var content = param.content, rules = param.rules;
    if (!content) {
        return null;
    }
    var ref = rules || {}, _columns = ref.columns, columns = _columns === void 0 ? [] : _columns, _isSubTitle = ref.isSubTitle, isSubTitle = _isSubTitle === void 0 ? false : _isSubTitle, verticalSpacing = ref.verticalSpacing, textStyle = ref.textStyle;
    var ref1 = textStyle || {}, _style = ref1.style, style = _style === void 0 ? Ui.RichTextStyle.Primary : _style;
    var isPrimaryColor = style === Ui.RichTextStyle.Primary;
    var icon = content.icon, _level = content.level, level = _level === void 0 ? "h2" : _level, text = content.text, lead = content.lead;
    var element = isSubTitle ? "div" : level;
    var HeadingComponent = isSubTitle ? Subtitle : headingMap[level];
    return /*#__PURE__*/ _jsxs(HeadingWrapper, {
        rules: {
            columns: columns,
            verticalSpacing: verticalSpacing
        },
        hasIcon: !!icon,
        children: [
            /*#__PURE__*/ _jsxs(HeadingComponent, {
                as: element,
                textColor: isPrimaryColor ? "default" : "white",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        content: icon,
                        rules: {
                            color: isPrimaryColor ? "primary" : "natural0",
                            size: [
                                [
                                    50
                                ],
                                [
                                    60,
                                    "sm"
                                ]
                            ]
                        }
                    }),
                    text
                ]
            }),
            lead && /*#__PURE__*/ _jsx(SecondaryText, {
                children: lead
            })
        ]
    });
};
